module.exports = __webpack_public_path__ + "fonts/luxor_727879b63b06f8929c140d6e71021390.ttf";